import { InsightsState } from '../../store/state';
import { InsightsAction, InsightsActions } from '../actions/insights.action';

const initialState: InsightsState = null;

const insightsReducer = (state: InsightsState = initialState, action: InsightsAction): InsightsState => {
  switch (action.type) {
    case InsightsActions.LoadInsights:
      return {
        ...state,
        isLoading: true,
        loaded: false,
        error: null,
      };
    case InsightsActions.LoadInsightsSuccess:
      return {
        ...state,
        isLoading: false,
        error: null,
        loaded: true,
        data: action.payload,
      };
    case InsightsActions.LoadInsightsError:
      return {
        ...state,
        isLoading: false,
        data: null,
        loaded: false,
        error: action.payload,
      };
    case InsightsActions.UpdateInsightsFilter:
      return {
        ...state,
        filter: {
          ...state?.filter,
          ...action.payload
        },
        data: {
          ...state?.data,
          ...action.payload
        }
      };
    default:
      return state;
  }
};

export default insightsReducer;
